/*
 * Copyright © 2016-2020 The Thingsboard Authors
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import privacuPolicyTemplate from './privacy-policy-dialog.tpl.html';

/* eslint-disable import/no-unresolved, import/default */

import logoSvg from '../../svg/agrolog_logo.svg';

/* eslint-enable import/no-unresolved, import/default */

/*@ngInject*/
export default function SignUpController($state, $mdDialog, $translate, toast, signUpService, loginService, $rootScope,
                                         $document) {
    var vm = this;

    vm.signupRequest = {
        firstName: '',
        lastName: '',
        email: '',
        password: ''
    };

    vm.signUp = signUp;
    vm.login = login;
    vm.openPrivacyPolicy = openPrivacyPolicy;

    vm.signupParams = $rootScope.signUpParams;
    vm.logoSvg = logoSvg;

    function doSignUp() {
        if (validateSignUpRequest()) {
            signUpService.signup(vm.signupRequest).then(function success(response) {
                if (response.data && response.data === 'INACTIVE_USER_EXISTS') {
                    promptToResendEmailVerification();
                } else {
                    $state.go('signup.emailVerification', { email: vm.signupRequest.email })
                }
            }, function fail() {
            });
        }
    }

    function promptToResendEmailVerification() {
        var dialog = $mdDialog.confirm()
            .title($translate.instant('signup.inactive-user-exists-title'))
            .htmlContent($translate.instant('signup.inactive-user-exists-text'))
            .ariaLabel($translate.instant('signup.inactive-user-exists-title'))
            .cancel($translate.instant('action.cancel'))
            .ok($translate.instant('signup.resend'));
        $mdDialog.show(dialog).then(function () {
            loginService.resendEmailActivation(vm.signupRequest.email).then(function success() {
                $state.go('signup.emailVerification', {email: vm.signupRequest.email });
            }, function fail() {
            });
        }, function () {
        });
    }

    function validateSignUpRequest() {
        if (vm.passwordCheck !== vm.signupRequest.password) {
            toast.showError($translate.instant('login.passwords-mismatch-error'));
            return false;
        }
        if (vm.signupRequest.password.length < 6) {
            toast.showError($translate.instant('signup.password-length-message'));
            return false;
        }
        if (angular.isUndefined(vm.signupRequest.recaptchaResponse) || vm.signupRequest.recaptchaResponse.length < 1) {
            toast.showError($translate.instant('signup.no-captcha-message'));
            return false;
        }
        if (!vm.acceptPrivacyPolicy) {
            toast.showError("You must accept our Privacy Policy");
            return false;
        }
        return true;
    }

    function openPrivacyPolicy($event) {
        if ($event) {
            $event.stopPropagation();
        }
        $mdDialog.show({
            controller: showPrivacyPolicyController,
            controllerAs: 'vm',
            templateUrl: privacuPolicyTemplate,
            parent: angular.element($document[0].body),
            clickOutsideToClose:true,
            fullscreen: true,
            targetEvent: $event
        }).then(function () {
            vm.acceptPrivacyPolicy = true;
        }, function () {
        });
    }

    function signUp() {
        doSignUp();
    }

    function login() {
        $state.go('login')
    }
}

/*@ngInject*/
function showPrivacyPolicyController($mdDialog, selfRegistrationService, $sce) {

    var vm = this;

    selfRegistrationService.loadPrivacyPolicy().then(function success(data) {
        vm.privacyPolicyText = $sce.trustAsHtml(data);
    });

    vm.accept = accept;
    vm.cancel = cancel;

    function cancel() {
        $mdDialog.cancel();
    }

    function accept() {
        $mdDialog.hide();
    }
}